import api from './index'
import { axios } from '@/utils/request'

export function login (params) {
  return axios({
    url: '/user/login',
    method: 'post',
    params: params
  })
}

export function getInfo () {
  return axios({
    url: api.UserInfo,
    method: 'get'
  })
}

export function editUserInfo (params) {
  return axios({
    url: api.EditUserInfo,
    method: 'put',
    params: params
  })
}

export function editUserAvatar (params) {
  return axios({
    url: api.EditUserAvatar,
    method: 'put',
    params: params
  })
}

export function getAllUserList (params) {
  return axios({
    url: api.AllUserList,
    method: 'get',
    params: params
  })
}

export function updatePermission (params) {
  return axios({
    url: api.UpdatePermission,
    method: 'put',
    params: params
  })
}

export function updateRolePermission (params) {
  return axios({
    url: api.UpdateRolePermission,
    method: 'post',
    params: params
  })
}

export function getRolePermission (params) {
  return axios({
    url: api.UpdateRolePermission,
    method: 'get',
    params: params
  })
}
